import { Route, Routes } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { RoleGuard } from './core/auth/guards/userRole.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'tickets' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'tickets',
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            // { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            // { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.routes'),
            },
            {
                path: 'encuesta-de-satisfaccion',
                loadChildren: () =>
                    import('app/modules/external/survey/survey.routes'),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/auth/unlock-session/unlock-session.routes'
                    ),
            },
        ],
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'financiadores',
                loadChildren: () =>
                    import(
                        'app/modules/admin/financiadores/financiadores.routes'
                    ),
            },
            {
                path: 'contactos',
                loadChildren: () =>
                    import('app/modules/admin/contactos/contactos.routes'),
            },
            {
                path: 'informacion',
                loadChildren: () =>
                    import('app/modules/admin/information/information.routes'),
            },
            {
                path: 'ayuda',
                loadChildren: () =>
                    import('app/modules/admin/help-center/help-center.routes'),
            },

            {
                path: 'balanceo',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'administracion-iis',
                    },
                    {
                        path: 'administracion-iis',
                        loadChildren: () =>
                            import('app/modules/admin/administracion-iis/administracion-iis.routes'),
                    },
                    {
                        path: 'administracion-servicios',
                        loadChildren: () =>
                            import('app/modules/admin/administracion-services/administracion-services.routes'),
                    },

                ],
            },

            {
                path: 'configuracion',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'usuarios',
                    },
                    {
                        path: 'usuarios',
                        loadChildren: () =>
                            import('app/modules/admin/usuarios/usuarios.routes'),
                    },
                    {
                        path: 'notificaciones',
                        loadChildren: () =>
                            import('app/modules/admin/notificaciones/notificaciones.routes'),
                    },

                ],
            },

            {
                path: 'asociaciones',
                loadChildren: () =>
                    import('app/modules/admin/asociaciones/asociaciones.routes'),
            },
            {
                path: 'notificaciones',
                loadChildren: () =>
                    import('app/modules/admin/notificaciones/notificaciones.routes'),
            },
            {
                path: 'pruebas',
                loadChildren: () =>
                    import('app/modules/admin/pruebas-internas/pruebas-internas.routes'),
            },
            {
                path: 'estadisticas',
                loadChildren: () =>
                    import('app/modules/admin/estadisticas/estadisticas.routes'),
            },
            {
                path: 'usuarios',
                loadChildren: () =>
                    import('app/modules/admin/usuarios/usuarios.routes'),
            },
            // {
            //     path: 'admin',
            //     loadChildren: () =>
            //         import('app/modules/admin/administrador/administrador.routes'),
            // },
        ],
    },
    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'prestadores',
                loadChildren: () =>
                    import('app/modules/admin/prestadores/prestadores.routes'),
            },
            {
                path: 'lugares-de-atencion',
                loadChildren: () =>
                    import(
                        'app/modules/admin/lugar-atencion/lugar-atencion.routes'
                    ),
            },
            {
                path: 'transacciones',
                loadChildren: () =>
                    import(
                        'app/modules/admin/transacciones/transacciones.routes'
                    ),
            },


            {
                path: 'operaciones',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'pasaportes',
                    },
                    {
                        path: 'pasaportes',
                        loadChildren: () =>
                            import('app/modules/admin/pasaportes/pasaportes.routes'),
                    },
                    {
                        path: 'sistemas',
                        loadChildren: () =>
                            import('app/modules/admin/sistemas/sistemas.routes'),
                    },
                    {
                        path: 'transcodificaciones',
                        loadChildren: () =>
                            import(
                                'app/modules/admin/transcodificaciones/transcodificaciones.routes'
                            ),
                    },
                ],
            },
            {
                path: 'tickets',
                loadChildren: () =>
                    import('app/modules/admin/tickets/tickets.routes'),
            },



            {
                path: 'tickets',
                loadChildren: () =>
                    import('app/modules/admin/tickets/tickets.routes'),
            },
        ],
    },
    { path: '**', redirectTo: '404-not-found' },
    {
        path: '404-not-found',
        pathMatch: 'full',
        loadChildren: () =>
            import(
                'app/modules/admin/pagina-no-encontrada/pagina-no-encontrada.routes'
            ),
    },
];
